export enum QuestDifficulty {
    NoEffort = 'NoEffort',
    Easy = 'Easy',
    Medium = 'Medium',
    Challenging = 'Challenging',
    Hardcore = 'Hardcore',
}

export enum AchievementRarity {
    Uncommon = 'Uncommon',
    Rare = 'Rare',
    Epic = 'Epic',
    Legendary = 'Legendary',
}

export enum QuestMetricType {
    Repeating = 'Repeating',
    Completion = 'Completion',
    Experience = 'Experience',
    Time = 'Time',
    External = 'External',
}

export type ListGoal = {
    completedXP: number;
    l1Target: number;
    l2Target: number;
    l3Target: number;
    l1CurrencyReward: number;
    l2CurrencyReward: number;
    l3CurrencyReward: number;
};
